// src/components/PrivateRoute.tsx
import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function PrivateRoute() {
  const auth = useContext(AuthContext);
  if (!auth) {
    // Context not provided for some reason
    return <Navigate to="/login" replace />;
  }

  const { user, loading } = auth;

  if (loading) {
    return <p>Loading…</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated! Render the matched child route
  return <Outlet />;
}
